/**
 * The fields a form produces besides the reader's own answers: its calculated
 * variables (form_data.variables, see
 * docs/superpowers/specs/2026-09-16-forms-variablen-rechnen-design.md) and
 * whether the reader submitted it.
 *
 * Both field lists hang these off a form -- conditionFields.js (editor-v2
 * panels, answer insert, preview, personas, segment editor) and
 * answerFields.js (the Vue-2 condition modal and the segment tab's type
 * lookup) -- so they are described here once. Two spellings of the label or
 * the type would be two condition editors disagreeing about the same path.
 *
 * `derived` marks them, because a reader cannot ANSWER them: the test personas
 * and the answer preview filter on it (answerPersonaModel.js).
 *
 * Plain JavaScript, no Vue, no dependency -- Jest cannot resolve `.ts`.
 */

// Written by the reader in conditions.js#buildData when the store has a
// completedAt. The '@' keeps it clear of block ids and `var_` variable ids.
export const SUBMITTED_FIELD_ID = '@submitted';

/**
 * @param {object} formData  The form document.
 * @param {object} [labels]  `{ submitted }` in the caller's interface
 *                           language; editor-v2 passes its own, the Vue-2
 *                           admin leaves it out and gets German.
 */
export function derivedFormFields(formData, labels) {
  const doc = formData && typeof formData === 'object' ? formData : {};
  const words = labels || {};
  const fields = [];
  (Array.isArray(doc.variables) ? doc.variables : []).forEach((variable) => {
    if (!variable || typeof variable.id !== 'string' || variable.id === '') return;
    fields.push({
      fieldId: variable.id,
      label: `Σ ${variable.name || variable.id}`,
      // Only 'number' and 'text' exist; anything else is read as a number,
      // the type every comparison on a score expects.
      fieldType: variable.type === 'text' ? 'text' : 'number',
      derived: 'variable',
    });
  });
  fields.push({
    fieldId: SUBMITTED_FIELD_ID,
    label: words.submitted || 'Formular abgeschickt',
    fieldType: 'boolean',
    derived: 'submitted',
  });
  return fields;
}
